module.exports = __webpack_public_path__ + "static/media/siddharth-palamaner-trip-banner.13f445c2.jpg";